import { NgModule } from '@angular/core';

import { ButtonModule } from '../../components/button';
import { SelectButtonDirective, SelectButtonGroupComponent } from './select-button';

@NgModule({
  imports: [
    ButtonModule
  ],
  declarations: [
    SelectButtonGroupComponent,
    SelectButtonDirective
  ],
  exports: [
    SelectButtonGroupComponent,
    SelectButtonDirective
  ]
})
export class SelectButtonModule {
}

